import React, { useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiPhone, FiPrinter, FiMail } from 'react-icons/fi';

export default function Contact() {
  useEffect(() => {
    // Script für Formaloo laden
    const script = document.createElement('script');
    script.src = "https://embed.formaloo.me/v1/main.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Aufräumen beim Verlassen der Komponente
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const lat = 51.021165;
  const lon = 6.087705;
  const offset = 0.0015;
  const bbox = `${lon - offset},${lat - offset},${lon + offset},${lat + offset}`;

  return (
    <section id="kontakt" className="py-24 bg-white">
      <div className="container px-4 mx-auto md:px-8">
        <div className="flex flex-col items-center mb-16 text-center">
          <h2 className="section-title">Kontakt & Lage</h2>
          <p className="section-subtitle">
            Haben Sie Fragen oder möchten Sie einen Besichtigungstermin vereinbaren? Wir stehen Ihnen gerne zur Verfügung.
          </p>
        </div>

        <div className="flex flex-col gap-12">
          {/* Obere Sektion: Kontaktdaten und Karte nebeneinander */}
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            <div className="p-8 border border-gray-100 rounded-sm shadow-sm bg-gray-50 h-full">
              <h3 className="mb-6 text-2xl font-bold text-emerald-950">Kontaktdaten</h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-sm bg-emerald-900 text-yellow-500 shrink-0">
                    <SafeIcon icon={FiMapPin} className="text-xl" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Adresse</h4>
                    <p className="text-gray-600">Waldhufenstr. 9<br/>52525 Heinsberg</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-sm bg-emerald-900 text-yellow-500 shrink-0">
                    <SafeIcon icon={FiPhone} className="text-xl" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Telefon</h4>
                    <a href="tel:024529963733" className="text-gray-600 hover:text-emerald-900">02452 - 9963733</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-sm bg-emerald-900 text-yellow-500 shrink-0">
                    <SafeIcon icon={FiPrinter} className="text-xl" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Fax</h4>
                    <p className="text-gray-600">02452 - 9963734</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-sm bg-emerald-900 text-yellow-500 shrink-0">
                    <SafeIcon icon={FiMail} className="text-xl" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">E-Mail</h4>
                    <a href="mailto:hkp@kueppers.biz" className="text-gray-600 hover:text-emerald-900">hkp@kueppers.biz</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="h-64 overflow-hidden border border-gray-200 rounded-sm lg:h-full min-h-[300px] shadow-sm">
              <iframe 
                width="100%" 
                height="100%" 
                frameBorder="0" 
                scrolling="no" 
                marginHeight="0" 
                marginWidth="0" 
                src={`https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lon}`}
                style={{ border: 'none' }}
                title="Karte Waldhufenstr. 9, Heinsberg"
              ></iframe>
            </div>
          </div>

          {/* Untere Sektion: Formaloo Embed auf voller Breite */}
          <div className="w-full p-4 border border-gray-200 rounded-sm shadow-lg bg-white relative overflow-hidden">
            <div className="mb-6 text-center">
              <h3 className="text-2xl font-bold text-emerald-950">Besichtigung anfragen</h3>
              <p className="text-gray-600 mt-2">Nutzen Sie unser Formular für eine schnelle Kontaktaufnahme.</p>
            </div>
            <div 
              className="formaloo--root-container" 
              data-form-slug="pAPN5rUa" 
              style={{ width: '100%', minHeight: '750px' }}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
}